import qs from 'qs'

// Init uses this code to select the Pixel. Registration may clear its own code,
// but this value survives until a new referral link or the browser clears storage.
const key = 'initAgentCode'
const recordKey = 'initAgentAttribution.v1'
let memory = ''
const stores = ['localStorage', 'sessionStorage']

function normalize (code) {
  return typeof code === 'string' ? code.trim() : ''
}

function read (name) {
  try { return normalize(window[name].getItem(key)) } catch (e) { return '' }
}

function sharedRecord () {
  const candidates = []
  try { candidates.push(JSON.parse(window.localStorage.getItem(recordKey))) } catch (e) {}
  try {
    const cookie = document.cookie.split(/;\s*/).find(item => item.indexOf(recordKey + '=') === 0)
    if (cookie) candidates.push(JSON.parse(decodeURIComponent(cookie.slice(recordKey.length + 1))))
  } catch (e) {}
  return candidates.filter(value => value && normalize(value.code) === value.code && value.code && Number.isFinite(value.updated))
    .sort((a, b) => b.updated - a.updated)[0] || null
}

function remember (code, shared) {
  memory = code
  try { window.sessionStorage.setItem(key, code) } catch (e) {}
  if (!shared) return
  const previous = sharedRecord()
  const record = { code, updated: Math.max(Date.now(), previous ? previous.updated + 1 : 0) }
  // localStorage has no application expiry. Cookie is a fallback, not the lifetime limit.
  try { window.localStorage.setItem(key, code) } catch (e) {}
  try { window.localStorage.setItem(recordKey, JSON.stringify(record)) } catch (e) {}
  try {
    document.cookie = recordKey + '=' + encodeURIComponent(JSON.stringify(record)) +
      ';path=/;max-age=31536000;SameSite=Lax' + (window.location.protocol === 'https:' ? ';Secure' : '')
  } catch (e) {}
}

export function agentCodeFromUrl () {
  const search = qs.parse(window.location.search.slice(1))
  const hash = window.location.hash || ''
  const index = hash.indexOf('?')
  const query = index < 0 ? {} : qs.parse(hash.slice(index + 1))
  return [query.agentCode, query.inviteCode, search.agentCode, search.inviteCode]
    .map(normalize).find(Boolean) || ''
}

export function getInitAgentCode (legacyCode) {
  const incoming = agentCodeFromUrl()
  const shared = sharedRecord()
  const local = read('localStorage')
  const code = incoming || memory || read('sessionStorage') || (shared && shared.code) || local || normalize(legacyCode)
  if (!code) return ''
  // Reads in an old tab must not overwrite a newer tab's referral. A new explicit
  // URL is allowed to replace it; ordinary refresh/logout never clears this record.
  remember(code, (!!incoming && incoming !== memory) || (!shared && (!local || local === code)))
  return code
}

// Keep the parameter in the redirect URL when no storage survives navigation.
export function hasPersistedInitAgentCode (code) {
  const shared = sharedRecord()
  return !!code && (stores.some(name => read(name) === code) || !!(shared && shared.code === code))
}

export function isPwaLaunch () {
  if (window.__elevenIcPwa !== true) return false
  return qs.parse(window.location.search.slice(1)).source === 'pwa' ||
    !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    !!(window.navigator && window.navigator.standalone)
}

export function restorePwaLaunchAgentCode () {
  if (!isPwaLaunch()) return ''
  const code = getInitAgentCode()
  if (code && !agentCodeFromUrl() && window.history && window.history.replaceState) {
    // The installed app has a stable /home start_url. Restore its referral before
    // the router and /init run, preserving the hash and other launch parameters.
    const separator = window.location.search ? '&' : '?'
    const target = window.location.pathname + window.location.search + separator +
      'agentCode=' + encodeURIComponent(code) + (window.location.hash || '')
    try { window.history.replaceState(window.history.state, '', target) } catch (e) {}
  }
  return code
}



// WEBPACK FOOTER //
// ./src/common/utils/initAgentCode.js